import React, { useState, useEffect } from "react";
import { useField } from "formik";
// import Grid from "@material-ui/core/Grid";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker
// } from "@material-ui/pickers";
// import DateFnsUtils from "@date-io/date-fns";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import { FormControl, Grid, TextField } from "@mui/material";

export default function DatePickerField(props) {
  const [field, meta, helper] = useField(props);
  const { touched, error } = meta;
  const { setValue } = helper;
  const isError = touched && error && true;
  const { value } = field;
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      setSelectedDate(date);
    }
  }, [value]);

  function _onChange(date) {
    if (date) {
      setSelectedDate(date);
      try {
        const ISODateString = date.toISOString();
        setValue(ISODateString);
      } catch (error) {
        setValue(date);
      }
    } else {
      setValue(date);
    }
  }

  return (
    // <Grid container>
    //   <MuiPickersUtilsProvider utils={DateFnsUtils}>
    //     <KeyboardDatePicker
    // {...field}
    // {...props}
    // value={selectedDate}
    // onChange={_onChange}
    // error={isError}
    // invalidDateMessage={isError && error}
    // helperText={isError && error}
    //     />
    //   </MuiPickersUtilsProvider>
    // </Grid>

    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          {...field}
          {...props}
          value={selectedDate}
          onChange={_onChange}
          invalidDateMessage={isError && error}
          renderInput={(params) => (
            <TextField
              {...params}
              error={isError}
              helperText={isError && error}
            />
          )}
        />
      </LocalizationProvider>
    </FormControl>
  );
}
